var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8392 5.95577C12.1396 6.25617 12.1396 6.74322 11.8392 7.04363L8.37761 10.5052C8.07721 10.8056 7.59016 10.8056 7.28976 10.5052L3.82822 7.04363C3.52781 6.74322 3.52781 6.25617 3.82822 5.95577C4.12862 5.65537 4.61567 5.65537 4.91607 5.95577L7.83368 8.87338L10.7513 5.95577C11.0517 5.65537 11.5387 5.65537 11.8392 5.95577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.2a9104231072a30b73b4999b0b91d9c8.svg";
export { ForwardRef as ReactComponent };